/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import { resetOrgUserSearch,setOrgUserSearch } from '../../../redux/orgUserSearchSlice';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import AdvancedSearchInputBox from '../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import DateInput from '../../../components/DateField';
import CustomCheckbox from '../../../components/Checkbox';
import DualInputField from '../../../components/DualInput';

export default function OrganizationUserSearch({handleOnSubmit,emptyField,setEmptyField,monitoringConditionSearch,observerSearch}) {
    const organizationUserSearch = useSelector(state => state.orgUserSearchData);
    const {isAdvancedSearchOpen,setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()

    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    const searchApplied = useSelector((state) => state?.orgUserSearchData?.org_user_searchApplied);

    
    // handleOnChangeUserDetails function
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;

        // Restrict input to only numbers, #, and * for specific fields
        if (['mobile_number', 'main_number', 'main_number_code', 'mobile_number_code'].includes(id)) {
            updatedValue = value.replace(/[^0-9*-]/g, '');
        }

        // Handle only string values with trim, otherwise leave the value as is
        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue;
        }

        const updatedState = { ...organizationUserSearch, [id]: updatedValue };

        // Special cases for username and email
        if (['user_name', 'user_name_domain'].includes(id)) {
            const isBothUserNameFieldsEmpty = updatedState.user_name === '' && updatedState.user_name_domain === '';
            if (isBothUserNameFieldsEmpty && updatedState.user_name_inverse === 'true') {
                updatedState.user_name_inverse = '';
            }
        } else if (['email_address', 'email_address_domain'].includes(id)) {
            const isBothEmailFieldsEmpty = updatedState.email_address === '' && updatedState.email_address_domain === '';
            if (isBothEmailFieldsEmpty && updatedState.email_address_inverse === 'true') {
                updatedState.email_address_inverse = '';
            }
        } else {
        // Uncheck `mobile_number_inverse` if both mobile fields are empty
            if ((id === 'mobile_number' || id === 'mobile_number_code') &&
            updatedState.mobile_number === '' && 
            updatedState.mobile_number_code === '' &&
            updatedState.mobile_number_inverse === 'true') 
            {
                updatedState.mobile_number_inverse = '';
            }

            // Uncheck `main_number_inverse` if both main number fields are empty
            if ((id === 'main_number' || id === 'main_number_code') &&
            updatedState.main_number === '' && 
            updatedState.main_number_code === '' &&
            updatedState.main_number_inverse === 'true') 
            {
                updatedState.main_number_inverse = '';
            }

            // Default handling for other fields
            if (!['mobile_number', 'mobile_number_code', 'main_number', 'main_number_code'].includes(id) && 
            updatedValue === '' && 
            updatedState[`${id}_inverse`] === 'true') 
            {
                updatedState[`${id}_inverse`] = '';
            }
        }

        // Dispatch the updated state to Redux
        dispatch(setOrgUserSearch(updatedState));
    };

    // handleCheckboxChange function
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;
    
        // Create an updated organizationUserSearch state
        let updatedState = { ...organizationUserSearch };
        
        if (field === 'active' || field === 'inactive') {
            // Update the status array if it's a status-related checkbox
            const updatedStatus = checked 
                ? [...(organizationUserSearch.status || []), field] 
                : (organizationUserSearch.status || []).filter((status) => status !== field);
    
            // Uncheck status_inverse if the status array is empty
            if (updatedStatus.length === 0) {
                updatedState.status_inverse = '';
            }
            updatedState.status = updatedStatus;

        }else if( field ==='admin' || field === 'user' ){
            
            const updatedPermission = checked 
                ? [...(organizationUserSearch?.permission || []), field] 
                : (organizationUserSearch?.permission || []).filter((permission) => permission !== field);
            
            // Uncheck permission_inverse if the permission array is empty
            if (updatedPermission.length === 0) {
                updatedState.permission_inverse = '';
            }
            updatedState.permission = updatedPermission;
        }
        else {
            // Handle other fields as boolean values
            updatedState[field] = checked ? 'true' : '';
        }
        // Dispatch the updated state to Redux
        dispatch(setOrgUserSearch(updatedState));
    };

    const dateformatSysconfig = useSelector(
        (state) => state?.systemConfigData?.globalVariables?.date_format
    );

    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);
    
    
    /**
     * The function `handleDateChange` validates and updates date input fields in a React application.
     */
    const handleDateChange = (newDate) => {
        setEmptyField(false);
        // Validate input: only numbers, and apply limits
        const validatedDay = /^[0-9]*$/.test(newDate.day) && newDate.day <= 31 ? newDate.day : '';
        const validatedMonth = /^[0-9]*$/.test(newDate.month) && newDate.month <= 12 ? newDate.month : '';
        const validatedYear = /^[0-9]*$/.test(newDate.year) ? newDate.year : '';
    
        // Check if the date is fully cleared
        const isDateCleared =
            !validatedDay.trim() && !validatedMonth.trim() && !validatedYear.trim();
    
        dispatch(setOrgUserSearch({
            ...organizationUserSearch,
            created_day: validatedDay,
            created_month: validatedMonth,
            created_year: validatedYear,
            // Uncheck the checkbox if the date fields are cleared
            created_date_inverse: isDateCleared ? '' : organizationUserSearch.created_date_inverse,
        }));
    };
    
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {
            dispatch(resetOrgUserSearch());
        }
    };

    /**
     * The function `isApplyButtonDisabled` checks if all values in the `organizationUserSearch` object are
     * considered empty based on their type.
     * @returns The function `isApplyButtonDisabled` is returning a boolean value. It checks all
     * key-value pairs in the `organizationUserSearch` object and returns `true` if all conditions are met for
     * each value to be considered as 'empty'.
     */
    const isApplyButtonDisabled = () => {
        return Object.entries(organizationUserSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetOrgUserSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)
    };

    /* The above code is using the `useEffect` hook in React to add an event listener for the "keydown"
    event on the window object. When a key is pressed, it checks if the key pressed is the "Escape"
    key, and if so, it calls the `handleClearAll` function. The `useEffect` hook also includes a
    cleanup function that removes the event listener when the component unmounts or when the
    dependencies array is empty. */
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    /* The above code snippet is a React useEffect hook that is triggered when the
    `isAdvancedSearchOpen` dependency changes. Within the useEffect hook, it performs the following
    actions: */
    useEffect(() => {
        dispatch(resetOrgUserSearch());
        const params = Object.fromEntries(searchParams);
        
        if (!params.search) return;
        
        const searchDecoded = decodeURIComponent(params.search);
        const updatedState = {};

        // Mapping alternate field names to the correct field name
        const fieldMappings = {
            template_name: 'first_name',
            created_by: 'last_name',
            patient_full_name : 'patient_full_name'
        };
        
        searchDecoded.split(';').forEach((segment) => {
            const match = segment.match(/([^=]+)=(ne:)?(.+)/);
            if (!match) return;
            
            let [, key, isInverse, value] = match;
            const inverseFlag = isInverse ? 'true' : '';

            // Normalize the key using fieldMappings
            key = fieldMappings[key] || key;

            switch (key) {
            case 'user_id':
            case 'first_name':
            case 'last_name':
            case 'patient_full_name':
                updatedState[key] = value === '__NULL__' ? '-' : value;
                updatedState[`${key}_inverse`] = inverseFlag;
                break;
                
            case 'created_at':
                const date = new Date(parseInt(value, 10) * 1000);
                updatedState.created_day = date.getDate().toString().padStart(2, '0');
                updatedState.created_month = (date.getMonth() + 1).toString().padStart(2, '0');
                updatedState.created_year = date.getFullYear().toString();
                updatedState.created_date_inverse = inverseFlag;
                break;
                
            case 'main_no_country_code-main_number':
            case 'main_country_code-main_number':
            case 'mob_no_country_code-mobile_number':
            case 'mobile_country_code-mobile_number':
                let [code, number] = value.replace(/^\+/, '').split('-');
                updatedState[`${key.includes('main') ? 'main' : 'mobile'}_number_code`] = code === '__NULL__' ? '-' : code;
                updatedState[`${key.includes('main') ? 'main' : 'mobile'}_number`] = number === '__NULL__' ? '-' : number;
                updatedState[`${key.includes('main') ? 'main' : 'mobile'}_number_inverse`] = inverseFlag;
                break;
                
            case 'user_name':
            case 'email_address':
                const [namePart, domainPart] = value.split('@');
                updatedState[key] = namePart === '__NULL__' ? '-' : namePart || '';
                updatedState[`${key}_domain`] = domainPart === '__NULL__' ? '-' : domainPart || '';
                updatedState[`${key}_inverse`] = inverseFlag;
                break;
                
            case 'status':
            case 'permission_access':
                updatedState[key === 'status' ? 'status' : 'permission'] = value === '__NULL__' ? '-' : decodeURIComponent(value);
                updatedState[`${key === 'status' ? 'status' : 'permission'}_inverse`] = inverseFlag;
                break;
                
            default:
                break;
            }
        });
        
        if (params.search_mode) {
            updatedState.match = params.search_mode === 'or';
        }
        
        setTimeout(() => {
            dispatch(setOrgUserSearch(updatedState));
        }, 0);
    }, [isAdvancedSearchOpen]);
    

    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => {handleOnSubmit(e);
                }} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={organizationUserSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${organizationUserSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!organizationUserSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!organizationUserSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        {!monitoringConditionSearch && <>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={"ID"}
                                        placeholder={"Enter ID"}
                                        id={"user_id"}
                                        data_testid={"user_id"}
                                        htmlFor={"user_id"}
                                        value={organizationUserSearch.user_id}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={15}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='user_id_inverse'
                                        checked={organizationUserSearch.user_id_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        disabled={organizationUserSearch?.user_id?.trim() === ""}
                                    />
                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <DualInputField
                                    label="Username"
                                    fieldPrefix="user_name"
                                    placeholder1="example"
                                    placeholder2="domain"
                                    searchData={organizationUserSearch}
                                    handleChange={handleOnChangeUserDetails}
                                />
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='user_name_inverse'
                                        checked={organizationUserSearch.user_name_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'user_name_inverse')}
                                        disabled={
                                            organizationUserSearch?.user_name_domain?.trim() === "" &&
                                        organizationUserSearch?.user_name?.trim() === ""
                                        }
                                    />
                                </div>
                            </div>
                        </>}
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={`${monitoringConditionSearch?'Template Name':'First Name'}`}
                                    placeholder={`Enter ${monitoringConditionSearch?'template':'first'} name`}
                                    id={"first_name"}
                                    data_testid={"first_name"}
                                    htmlFor={"first_name"}
                                    value={organizationUserSearch?.first_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <CustomCheckbox
                                    id='first_name_inverse'
                                    checked={organizationUserSearch?.first_name_inverse === 'true'}
                                    onChange={(e) => handleCheckboxChange(e, 'first_name_inverse')}
                                    disabled={organizationUserSearch?.first_name?.trim() === ""}
                                />
                            </div>
                        </div>
                        {!monitoringConditionSearch &&
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={"Last Name"}
                                        placeholder={"Enter last name"}
                                        id={"last_name"}
                                        data_testid={"last_name"}
                                        htmlFor={"last_name"}
                                        value={organizationUserSearch?.last_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='last_name_inverse'
                                        checked={organizationUserSearch?.last_name_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'last_name_inverse')}
                                        disabled={organizationUserSearch?.last_name?.trim() === ""}
                                    />
                                </div>
                            </div>}
                        {observerSearch &&
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={"Patient Associated with"}
                                        placeholder={"Enter patient associated with"}
                                        id={"patient_full_name"}
                                        data_testid={"patient_full_name"}
                                        htmlFor={"patient_full_name"}
                                        value={organizationUserSearch?.patient_full_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='patient_full_name_inverse'
                                        checked={organizationUserSearch?.patient_full_name_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'patient_full_name_inverse')}
                                        disabled={organizationUserSearch?.patient_full_name?.trim() === ""}
                                    />
                                </div>
                            </div>
                        }
                        {!monitoringConditionSearch && !observerSearch && <>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <p className='text-xs font-normal text-[#000000] more-lines'>Status</p>
                                    <div className='flex items-center'>
                                        <CustomCheckbox
                                            id='active'
                                            label='Active'
                                            checked={organizationUserSearch?.status?.includes('active')}
                                            onChange={(e) => handleCheckboxChange(e, 'active')}
                                            disabled={false}
                                            classkey={'mark-check2'}
                                        />
                                        <CustomCheckbox
                                            id='inactive'
                                            label='Inactive'
                                            checked={organizationUserSearch?.status?.includes('inactive')}
                                            onChange={(e) => handleCheckboxChange(e, 'inactive')}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                                <div className='relative w-[65px] mt-[16px]'>
                                    <CustomCheckbox
                                        id='status_inverse'
                                        checked={organizationUserSearch?.status_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'status_inverse')}
                                        disabled={organizationUserSearch?.status?.length === 0}
                                    />

                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <p className='text-xs font-normal text-[#000000] more-lines'>Permission</p>
                                    <div className='flex items-center'>
                                        <CustomCheckbox
                                            id='admin'
                                            label='Admin'
                                            checked={organizationUserSearch?.permission?.includes('admin')}
                                            onChange={(e) => handleCheckboxChange(e, 'admin')}
                                            classkey={'mark-check2'}
                                        />
                                        <CustomCheckbox
                                            id='user'
                                            label='User'
                                            checked={organizationUserSearch?.permission?.includes('user')}
                                            onChange={(e) => handleCheckboxChange(e, 'user')}
                                        />
                                    </div>
                                </div>
                                <div className='relative w-[65px] mt-[16px]'>
                                    <CustomCheckbox
                                        id='permission_inverse'
                                        checked={organizationUserSearch?.permission_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'permission_inverse')}
                                        disabled={organizationUserSearch?.permission?.length === 0}
                                    />
                                </div>
                            </div>
                        </>}
                        {!monitoringConditionSearch &&<>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <DualInputField
                                    label="Email Address"
                                    fieldPrefix="email_address"
                                    placeholder1="example"
                                    placeholder2="domain"
                                    searchData={organizationUserSearch}
                                    handleChange={handleOnChangeUserDetails}
                                />
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='email_address_inverse'
                                        checked={organizationUserSearch?.email_address_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'email_address_inverse')}
                                        disabled={organizationUserSearch?.email_address?.trim() === "" && organizationUserSearch?.email_address_domain.trim() === ""}
                                    />
                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Mobile Number</p>
                                    <div className='w-full flex items-center'>
                                        <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                        <div className='w-[40%]'>
                                            <AdvancedSearchInputBox
                                                label={""}
                                                placeholder={""}
                                                id={"mobile_number_code"}
                                                data_testid={"mobile_number_code"}
                                                htmlFor={"mobile_number_code"}
                                                value={organizationUserSearch?.mobile_number_code}
                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                maxLength={3}
                                            />
                                        </div>
                                        <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={"Enter number"}
                                            id={"mobile_number"}
                                            data_testid={"mobile_number"}
                                            htmlFor={"mobile_number"}
                                            value={organizationUserSearch?.mobile_number}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={20}
                                        />
                                    </div>
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='mobile_number_inverse'
                                        checked={organizationUserSearch?.mobile_number_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'mobile_number_inverse')}
                                        disabled={organizationUserSearch?.mobile_number_code?.trim() === "" && organizationUserSearch?.mobile_number?.trim() === ""}
                                    />

                                </div>
                            </div>
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Main Number</p>
                                    <div className='w-full flex items-center'>
                                        <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                        <div className='w-[40%]'>
                                            <AdvancedSearchInputBox
                                                label={""}
                                                placeholder={""}
                                                id={"main_number_code"}
                                                data_testid={"main_number_code"}
                                                htmlFor={"main_number_code"}
                                                value={organizationUserSearch?.main_number_code}
                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                maxLength={3}
                                            />
                                        </div>
                                        <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={"Enter number"}
                                            id={"main_number"}
                                            data_testid={"main_number"}
                                            htmlFor={"main_number"}
                                            value={organizationUserSearch?.main_number}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={20}
                                        />
                                    </div>
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='main_number_inverse'
                                        checked={organizationUserSearch?.main_number_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'main_number_inverse')}
                                        disabled={organizationUserSearch?.main_number_code?.trim() === "" && organizationUserSearch?.main_number?.trim() === ""}
                                    />
                                </div>
                            </div>
                        </>}
                        {!observerSearch &&
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <DateInput
                                        labeltext={'Created Date'}
                                        date={{
                                            day: organizationUserSearch.created_day,
                                            month: organizationUserSearch.created_month,
                                            year: organizationUserSearch.created_year,
                                        }}
                                        onDateChange={handleDateChange}
                                        dateFormat={dateFormat}
                                        idPrefix="created"
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='created_date_inverse'
                                        checked={organizationUserSearch.created_date_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'created_date_inverse')}
                                        disabled={organizationUserSearch?.created_day?.trim() === "" || organizationUserSearch?.created_month?.trim() === "" || organizationUserSearch?.created_year?.trim() === ""}
                                    />

                                </div>
                            </div>
                        }
                        {monitoringConditionSearch && 
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <AdvancedSearchInputBox
                                        label={`${monitoringConditionSearch ? 'Created By':'Last Name'}`}
                                        placeholder={`Enter ${monitoringConditionSearch ? 'created by':'last name'}`}
                                        id={"last_name"}
                                        data_testid={"last_name"}
                                        htmlFor={"last_name"}
                                        value={organizationUserSearch?.last_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <CustomCheckbox
                                        id='last_name_inverse'
                                        checked={organizationUserSearch?.last_name_inverse === 'true'}
                                        onChange={(e) => handleCheckboxChange(e, 'last_name_inverse')}
                                        disabled={organizationUserSearch?.last_name?.trim() === ""}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
